import { useQuery } from "@tanstack/react-query";
import { Plane, UserCheck, Users, UserX } from "lucide-react";

import { pessoasQueries } from "@/services/api/queries/pessoas.queries";
import { NumberKpiCard } from "@/components/shared/NumberKpiCard";

export function UserResumoCards() {
  const { data, isLoading, isError } = useQuery(pessoasQueries.resumo());

  if (isError) return null;

  const cards = [
    { title: "Total de usuários", value: data?.total ?? 0, icon: Users, variant: "blue" as const },
    { title: "Ativos", value: data?.ativos ?? 0, icon: UserCheck, variant: "emerald" as const },
    { title: "Inativos", value: data?.inativos ?? 0, icon: UserX, variant: "default" as const },
    { title: "Em férias", value: data?.emFerias ?? 0, icon: Plane, variant: "amber" as const },
  ];

  return (
    <div className="scrollbar-none -mx-4 flex snap-x snap-mandatory flex-col gap-4 overflow-x-auto px-4 pb-2 sm:mx-0 sm:grid sm:grid-cols-2 sm:px-0 2xl:grid-cols-4">
      {cards.map(({ title, value, icon, variant }) => (
        <div key={title} className="min-w-[260px] flex-1 snap-center sm:min-w-0">
          <NumberKpiCard
            title={title}
            value={value}
            icon={icon}
            variant={variant}
            loading={isLoading}
          />
        </div>
      ))}
    </div>
  );
}
